module.exports = __webpack_public_path__ + "static/img/gws founder copy.f196bf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws founder copy.jpg
// module id = 6L3i
// module chunks = 1